import { RouteObject } from "react-router";
import { Navigate } from "react-router-dom";

import AuthGuard from "@/layouts/AuthGuard";

import Bid from "@/pages/Bid";
import BidDetail from "@/pages/Bid/Detail";
import BidFavorite from "@/pages/Bid/favorite";
import PastBusiness from "@/pages/PastBusiness";
import BidSpecification from "src/pages/Bid/Specification";
import BidSpecificationFavorite from "@/pages/Bid/favorite/Specification";
import BidPlan from "@/pages/Bid/Plan";
import BidPlanFavorite from "@/pages/Bid/favorite/Plan";
import ProjectManagement from "./pages/Project/Management";
import ProjectDetail from "./pages/Project/Detail";
import ProjectManagementLayout, {
  ProjectGroupsLayout,
} from "./pages/Project/layout";
import Setting from "@/pages/Setting";
import TaskManagement from "./pages/Task/Management";
import TaskDetail from "./pages/Task/Detail";
import NotFoundPage from "./pages/Errors/404";
import { RequiredParamGuard } from "./guards/RequiredParamGuard";
import BidAnalytics from "./pages/Bid/Analytics";
import ProjectEstimate from "./pages/Project/Estimate";
import ProjectScenario from "./pages/Project/Scenario";
import DirectEstimatePage from "./pages/Project/Estimate/DirectEstimatePage";
import Login from "@/pages/Login";
import BidSimilar from "@/pages/Bid/Similar";
import ApprovalResponseManagement from "./pages/ApprovalResponse";
import ApprovalRequestManagement from "./pages/Approval";
import ApprovalDetailPage from "./pages/ApprovalDetail";
import DashboardBid from "@/pages/Dashboard/Bid";
import DashboardProject from "@/pages/Dashboard/Project";

export type NewRouteObject = Omit<RouteObject, "children"> & {
  title?: string;
  icon?: string;
  iconOpen?: string;
  children?: NewRouteObject[];
  link?: string;
  alt?: string;
  hidden?: boolean;
  navigate?: string;
  disabled?: boolean;
};

export const routes: NewRouteObject[] = [
  {
    path: "",
    element: <AuthGuard />,
    children: [
      {
        path: "dashboard",
        children: [
          { index: true, element: <Navigate to="bid" replace /> },
          { path: "bid", element: <DashboardBid /> },
          { path: "project", element: <DashboardProject /> },
        ],
      },
      {
        path: "bid",
        children: [
          {
            path: "domestic",
            children: [
              {
                path: "list",
                element: <Bid />,
              },
              {
                path: "specification",
                element: <BidSpecification />,
              },
              {
                path: "plan",
                element: <BidPlan />,
              },
              {
                path: "failure",
                element: <div>failure</div>,
              },
              {
                path: "detail/:projectType/:projectId",
                element: <BidDetail />,
              },
              {
                path: "similar/:projectType/:projectId",
                element: <BidSimilar />,
              },
              {
                path: "calculate",
                element: <div>투찰 가격 산출</div>,
              },
              {
                path: "detail/:projectType/:projectId/spec-analysis",
                element: <BidAnalytics />,
              },
            ],
          },
          {
            path: "favorite",
            children: [
              { path: "list", element: <BidFavorite /> },
              {
                path: "specification",
                element: <BidSpecificationFavorite />,
              },
              {
                path: "plan",
                element: <BidPlanFavorite />,
              },
            ],
          },
        ],
      },
      {
        path: "past",
        element: <PastBusiness />,
      },
      {
        path: "management",
        children: [
          {
            path: "projects",
            element: <ProjectManagementLayout />,
            children: [
              {
                path: "",
                element: <ProjectManagement />,
              },
              {
                path: ":group_id",
                element: <ProjectGroupsLayout />,
                children: [
                  {
                    path: "",
                    element: <ProjectDetail />,
                  },
                  {
                    path: "estimates/:estimate_id/original/:original_id/itemsheet/:itemsheet_id",
                    element: <DirectEstimatePage />,
                  },
                  {
                    path: "estimates",
                    element: <ProjectEstimate />,
                  },
                  {
                    path: "scenario",
                    element: <ProjectScenario />,
                  },
                ],
              },
            ],
          },
          {
            path: "tasks",
            element: <TaskManagement />,
          },
          {
            path: "projects/:group_id/tasks/:task_id",
            element: <TaskDetail />,
          },
        ],
      },
      {
        path: "approvals",
        children: [
          {
            path: "requests",
            element: <ApprovalRequestManagement />,
          },
          {
            path: "responses",
            element: <ApprovalResponseManagement />,
          },
          {
            path: ":approval_id",
            element: <ApprovalDetailPage />,
          },
        ],
      },
      {
        path: "setting",
        children: [
          { index: true, element: <Setting /> },
          { path: "substitute", element: <Setting /> },
        ],
      },
      {
        path: "/404",
        element: <NotFoundPage />,
      },
    ],
  },
  { path: "login", element: <Login /> },
];
